import { Config, SurveyEvent } from './types'
import { openSurvey } from './widget/widget-dom-api'
import { coreFrameId } from './constant'

type EventPayload = {
  event: SurveyEvent
  surveyId: string
}

const validateUrlMatchPattern = (
  url: string,
  { pageUrlMatchPattern, pageUrl }: SurveyEvent
) => {
  if (pageUrlMatchPattern === 'contains') {
    return url.includes(pageUrl)
  }

  if (pageUrlMatchPattern === 'exact') {
    return url === pageUrl
  }

  if (pageUrlMatchPattern === 'starts_with') {
    return url.startsWith(pageUrl)
  }

  if (pageUrlMatchPattern === 'ends_with') {
    return url.endsWith(pageUrl)
  }

  return false
}

const handlePageUrl = (appId: string, { event, surveyId }: EventPayload) => {
  const url = window.location.href

  if (!validateUrlMatchPattern(url, event)) {
    return
  }

  openSurvey({
    frameId: coreFrameId,
    appId,
    executedFrom: 'auto',
    showInitialLoading: false,
    surveyId,
  })
}

export const handleEvents = (appId: string, config: Config) => {
  const executeEvents = () => {
    config.surveys.forEach(survey =>
      survey.events.forEach(event =>
        handlePageUrl(appId, {
          surveyId: survey.id,
          event,
        })
      )
    )
  }

  if (document.readyState === 'complete') {
    executeEvents()
  } else {
    const readyListener = () => {
      executeEvents()
      window.removeEventListener('load', readyListener)
    }

    window.addEventListener('load', readyListener)
  }

  const events = [
    'hashchange',
    'popstate',
    'pushState',
    'replaceState',
  ] as const

  events.forEach(e => window.addEventListener(e, executeEvents, true))

  return {
    dispose: () =>
      events.forEach(e => window.removeEventListener(e, executeEvents)),
  }
}
